export default __webpack_public_path__ + "static/media/exclude-dates-icon.f7290b68.svg";